import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, size, space, textStyle } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';
import { visuallyHidden } from '../../utils/visuallyHidden';

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${space['space-400']};
  padding: ${space['space-400']} 0;
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.subtle};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-400']};
  min-width: 0;
  flex: 1;
`;

export const LeftContentLink = styled.a`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-400']};
  min-width: 0;
  flex: 1;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover .booking-summary-title,
  &:focus-visible .booking-summary-title {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid currentColor;
    outline-offset: ${space['space-050']};
    border-radius: ${size.radius['radius-sm']};
  }
`;

export const Thumbnail = styled.div`
  width: 64px;
  height: 64px;
  border-radius: ${radius('image', 'radius-sm')};
  overflow: hidden;
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ThumbnailImage = styled(EntityImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${semantic.bg.surfaceSubtle};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  min-width: 0;
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const MetaLine = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const RowLink = styled.a`
  align-self: flex-start;
  font-family: ${textStyle.body.sm.link.fontFamily};
  font-size: ${textStyle.body.sm.link.fontSize};
  font-weight: ${textStyle.body.sm.link.fontWeight};
  line-height: ${textStyle.body.sm.link.lineHeight};
  letter-spacing: ${textStyle.body.sm.link.letterSpacing};
  color: ${semantic.text.primary};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid currentColor;
    outline-offset: ${space['space-050']};
    border-radius: ${size.radius['radius-sm']};
  }
`;

export const RowLinkHint = styled.span`
  ${visuallyHidden}
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${space['space-050']};
  flex-shrink: 0;
  text-align: right;
`;

export const PriceAmount = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const PriceNote = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  white-space: nowrap;
`;
